var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissionsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151",
    transform: "translate(-112 -637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    transform: "translate(112 637)",
    fill: "none",
    stroke: "#2c2b34",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "np_form_6136886_000000",
    transform: "translate(123.017 648.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M50.017,18.979a5.365,5.365,0,0,0-3.34,1.6l-9.188,9.207A8.43,8.43,0,0,0,35,35.8V37.3a2.235,2.235,0,0,0,2.235,2.235h1.507a8.435,8.435,0,0,0,6-2.484l9.2-9.193a5.364,5.364,0,0,0,1.618-3.34,5.137,5.137,0,0,0-5.541-5.541Zm2.859,5.134a2.442,2.442,0,0,1-.719,1.735l-9.3,9.3a5.767,5.767,0,0,1-4.111,1.7h-1.06V35.8a5.769,5.769,0,0,1,1.7-4.106l9.31-9.31a2.449,2.449,0,0,1,4.183,1.734Z",
    transform: "translate(-27.849 -18.962)",
    fill: "#2c2b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M23.916,48.921H40A4.917,4.917,0,0,0,44.921,44V38.642a1.341,1.341,0,0,0-2.681,0V44A2.235,2.235,0,0,1,40,46.239H23.916A2.234,2.234,0,0,1,21.681,44V27.916a2.234,2.234,0,0,1,2.235-2.235h5.363a1.341,1.341,0,0,0,0-2.681H23.916A4.917,4.917,0,0,0,19,27.916V44A4.917,4.917,0,0,0,23.916,48.921Z",
    transform: "translate(-19 -21.196)",
    fill: "#2c2b34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionsImg);
export default __webpack_public_path__ + "static/media/missions_img.0484bc8c6ca7b8d1ca1235cfe77a1dbf.svg";
export { ForwardRef as ReactComponent };